import '../styles/LandingPage/Advisory.css';

const cards = [
  {
    num: '01',
    title: 'IFRS 17 Technical Advisory',
    bg: 'I',
    items: [
      'Methodology review & validation',
      'CSM engine validation',
      'Risk Adjustment design',
      'Disclosure structuring',
      'Independent technical peer review',
    ],
  },
  {
    num: '02',
    title: 'Capital & Solvency Advisory',
    bg: 'II',
    items: [
      'Economic Capital modelling',
      'Stress testing design',
      'ORSA framework support',
      'Capital optimisation analysis',
    ],
  },
  {
    num: '03',
    title: 'Independent Model Validation',
    bg: 'III',
    items: [
      'Assumption governance review',
      'Model risk assessment',
      'Regulatory submission support',
    ],
  },
  {
    num: '04',
    title: 'Product & Profitability Advisory',
    bg: 'IV',
    items: [
      'Profit testing frameworks',
      'Product structure evaluation',
      'Embedded value analysis',
    ],
  },
];

const stats = [
  { num: '12+', label: 'Publications' },
  { num: '4', label: 'Research Pillars' },
  { num: '100%', label: 'Peer-Reviewed' },
];

export default function Advisory() {
  return (
    <section className="advisory-section" id="advisory">
      {/* Animated Background */}
      <div className="adv-bg-canvas">
        <div className="adv-blob adv-blob-1" />
        <div className="adv-blob adv-blob-2" />
        <div className="adv-blob adv-blob-3" />
        <div className="adv-noise" />
        <div className="adv-diagonal adv-diagonal-1" />
        <div className="adv-diagonal adv-diagonal-2" />
        <div className="adv-diagonal adv-diagonal-3" />
      </div>

      <div className="adv-wrapper">
        {/* Left: Typography */}
        <div className="adv-left">
          <div className="adv-phase-tag">Phase 2 — Advisory</div>
          <h2>
            <span className="line-1">Where Research</span>
            <span className="line-2">Becomes Action.</span>
          </h2>
          <p className="adv-intro">
            When Actyra advises, the work is already done. Every engagement is backed
            by published, peer-tested research — no recycled templates, no generic frameworks.
          </p>
          <div className="adv-scroll-hint">
            <span className="line" />
            <span>Explore Services</span>
          </div>
        </div>

        {/* Right: Cards */}
        <div className="adv-right">
          <div className="adv-cards">
            {cards.map((card) => (
              <div className="adv-card" key={card.num}>
                <div className="adv-card-num">{card.num}</div>
                <h3>{card.title}</h3>
                <ul className="adv-card-list">
                  {card.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
                <div className="adv-watermark">{card.bg}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Stats */}
      <div className="adv-stats">
        {stats.map((stat) => (
          <div className="adv-stat" key={stat.label}>
            <div className="adv-stat-num">{stat.num}</div>
            <div className="adv-stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}